/*// src/components/Logout.js
import { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import Cookies from 'js-cookie';

const Logout = () => {
  useEffect(() => {
    // Очистка данных аутентификации
    localStorage.removeItem('authToken');
    Cookies.remove('team_id', { path: '/' });
  }, []);

  return <Navigate to="/" replace />;
};

export default Logout;*/

// src/components/Logout.js
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';

const Logout = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const confirmLogout = window.confirm('Вы уверены, что хотите выйти?');
    
    if (confirmLogout) {
      // Очистка данных аутентификации
      localStorage.removeItem('authToken');
      Cookies.remove('team_id', { path: '/' });
      Cookies.remove('selectedGame', { path: '/' });
      navigate('/', { replace: true });
    } else {
      // Возврат на предыдущую страницу
      navigate(-1, { replace: true });
    }
  }, [navigate]);

  return null; // Компонент ничего не рендерит
};

export default Logout;